export default "__VITE_ASSET__52df026b__"